import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const TransmittalRCE_EFS = () => {
  const faqs = [
    {
      question: 'Q: What is the "RCE Transmittal EFS (SB-30)" feature used for?',
      answer:
        "A: This feature allows users to generate Request for Continued Examination (RCE) transmittal forms in bulk using the recommended SB-30 format from Patent Center.",
    },
    {
      question: "Q: What inputs are required for generating SB-30 forms?",
      answer:
        "A: You need to provide one or more U.S. application numbers. Additionally, either the attorney or applicant name is required. If selecting attorney, the attorney name and registration number must be entered.",
    },
    {
      question: "Q: How many application numbers can be entered at once?",
      answer:
        "A: You can enter up to 500 application numbers at a time for bulk document generation.",
    },
    {
      question: "Q: Can I generate forms for multiple applications at once?",
      answer:
        "A: Yes, you can enter multiple application numbers separated by commas or paste a list directly from Excel to generate forms in bulk.",
    },
    {
      question: "Q: Are all fields mandatory while configuring the form?",
      answer:
        "A: No, most fields are optional. However, attorney or applicant name is mandatory and will be displayed on the generated forms.",
    },
    {
      question: "Q: Can I include an attorney signature in the generated forms?",
      answer:
        "A: Yes, you can include the attorney signature by selecting the signature checkbox during configuration.",
    },
    {
      question: "Q: In which format are the forms downloaded?",
      answer:
        "A: The forms are generated in PDF format and provided as a ZIP file when multiple applications are processed.",
    },
    {
      question: "Q: Where can I download the generated forms?",
      answer:
        "A: The generated forms can be downloaded directly from the JUNE interface via a downloadable link.",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": { margin: 0 },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ whiteSpace: "pre-line" }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default TransmittalRCE_EFS;